/* eslint-disable react/no-danger */
import React from 'react';

interface BiddingFileProps {
  url: string;
  filename: string;
}

const BiddingFile = (props: BiddingFileProps) => {
  const { url, filename } = props;

  const { REACT_APP_API_ENDPOINT } = process.env;

  return (
    <a
      className="btn btn-primary btn-sm mr-1 mb-1"
      href={`${REACT_APP_API_ENDPOINT}${url}`}
      target="_blank"
      rel="noreferrer"
    >
      {filename}
    </a>
  );
};

export default BiddingFile;
